import {
  GET_SETPOINTS,
  SETPOINTS_IS_LOADING,
  SETPOINTS_MANAGEMENT_ERROR,
  SETPOINTS_SET_CURRENT_PAGE,
  SETPOINTS_SET_PAGE_FILTER,
  SETPOINTS_SET,
  SETPOINTS_UPDATE_SAVE_STATUS,
  SETPOINTS_SET_CHANGE,
  SETPOINTS_SET_FILTERED_RESULTS,
  SETPOINTS_CLEANUP
} from '../constants/index';
import { initialSetpointsState } from './initialState';

const setpointsReducer = (state = initialSetpointsState, action) => {
  const { payload, type } = action;
  switch (type) {
    case GET_SETPOINTS: {
      const { data } = payload;
      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          ...data.setpoints,
          isDataPresent: true,
          isLoading: data.isLoading,
          redirect: false
        }
      };
    }

    case SETPOINTS_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          isLoading: isLoading
        }
      };
    }

    case SETPOINTS_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          ...data
        }
      };
    }

    case SETPOINTS_SET_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          currentPage
        }
      };
    }

    case SETPOINTS_SET_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          filter
        }
      };
    }

    case SETPOINTS_UPDATE_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          ...data
        }
      };
    }

    case SETPOINTS_SET: {
      let { setpoints } = payload;

      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          isOpSuccessful: false,
          showBanner: false,
          selectedSetpoints: {
            ...state.setpoints.selectedSetpoints,
            ...setpoints.selectedSetpoints
          }
        }
      };
    }

    case SETPOINTS_SET_CHANGE: {
      let { selectedSetpoints } = payload;

      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          isOpSuccessful: false,
          showBanner: false,
          redirect: false,
          selectedSetpoints: {
            ...state.setpoints.selectedSetpoints,
            ...selectedSetpoints
          }
        }
      };
    }

    case SETPOINTS_SET_FILTERED_RESULTS: {
      const { filteredResults } = payload;
      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          ...filteredResults
        }
      };
    }

    case SETPOINTS_CLEANUP: {
      let { setpoints } = payload;
      return {
        ...state,
        setpoints: {
          ...state.setpoints,
          ...setpoints
        }
      };
    }

    default:
      return state;
  }
};

export default setpointsReducer;
